import { useEffect, useState } from "react";
import { UpOutlined, DownOutlined, FormOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { useForm } from 'form-render';
import { Drawer, Button } from 'antd';
import CompForm from "../comp-form";
import Choose from './choose';
import { CompList } from './component-list';
import './index.css';



function randomId() {
    return Math.random().toString(36).slice(2);
}

function render({
    node, nowChooseItem, onDelete, onAdd, onUp, onDown, onChoose, accId, shopId, componentList = CompList
}) {
    const {
        component, props
    } = node;
    const item = componentList.find(i => i.component === component);
    return (
        <div className={`view-compent-item ${node.nodeId === nowChooseItem?.nodeId? 'choose' : ''}`} key={node.nodeId}>
            <div className="component-set-list">
                <UpOutlined className="set-icon" onClick={() => onUp(node)} />
                <DownOutlined className="set-icon" onClick={() => onDown(node)} />
                <PlusOutlined className="set-icon" onClick={() => onAdd(node)} />
                <FormOutlined className="set-icon" onClick={() => onChoose(node)} />
                <DeleteOutlined className="set-icon" onClick={() => onDelete(node)} />
            </div>
            <div className="component-render-warp"  onClick={() => onChoose(node)}>
            {
                item.render?
                    item.render({...props, accId, shopId}) :
                    <img src={item.img} className="component-image" />
            }
            </div>
        </div>
    )
}
 
function Editor(props) {
    
    const {
        accId, shopId, list = [], onChange, componentList = CompList
    } = props;

    const [choosItem, setChooseItem] = useState(null);
    const [addComp, setAddComp] = useState({visible: false});
    const [showList, setShowList] = useState([])

    const form = useForm();
    
    useEffect(() => {
        onChange(showList)
    }, [showList]);

    useState(()=> {
        console.log(list,'-----')
        list.forEach(item => {
            item.nodeId = item.nodeId || randomId()
        })
        setShowList(list)
    }, [list]);

    useEffect(() => {
        form.resetFields();
        if (!choosItem) {
            // 如果没有这个
            return
        } 
        compMeta = componentList.find(i => i.component === choosItem?.component);
        form.setSchema(compMeta.propsSchema, true);
        form.setValues(choosItem.props);
    }, [choosItem]);

    function onAdd(node) {
        let nodeId;
        if (node) {
            nodeId = node.nodeId;
        }
        setAddComp({
            visible: true,
            nodeId
        })
    }
    function onUp(node) {
        let index = showList.findIndex(i => i.nodeId === node.nodeId);
        if (index <= 0) {
            return
        }
        showList[index] = showList[index - 1];
        showList[index - 1] = node;
        setShowList([...showList]);
    }
    function onDown(node) {
        let index = showList.findIndex(i => i.nodeId === node.nodeId);
        if (index >= showList.length  - 1) {
            return
        }
        showList[index] = showList[index + 1];
        showList[index + 1] = node;
        setShowList([...showList]);
    }
    function onDelete(node) {
        let index = showList.findIndex(i => i.nodeId === node.nodeId);
        if (index < 0) {
            return
        }
        showList.splice(index, 1);
        if (node.nodeId === choosItem?.nodeId) {
            setChooseItem(null)
        }
        setShowList([...showList]);
    }
    function onChangeFormValue(allValues) {
        let index = showList.findIndex(i => i.nodeId === choosItem?.nodeId);
        if (index < 0) {
            return
        }
        showList[index].props = allValues;
        setShowList([...showList]);
    }
    function onChoose(node) {
        setChooseItem(node);
    }
    function confirmAdd(item) {
        const {
            nodeId
        } = addComp;
        let index = showList.length - 1;
        if (nodeId) {
            index = showList.findIndex(i => i.nodeId === nodeId)
            if (index < 0) {
                index = showList.length - 1;
            }
        }
        const node = {
            nodeId: randomId(),
            component: item.component,
            name: item.name,
            props: {}
        };
        showList.splice(index + 1, 0, node)
        setChooseItem(node);
        setShowList([...showList]);
        setAddComp({visible: false})
    }

    let compMeta = null;
    if (choosItem) {
        compMeta = componentList.find(i => i.component === choosItem?.component);
    }
    
    return (
        <div className="editor-content">
            <div className="the-view">
                
                {/* 手机外框 */}
                <div className="phone-frame">
                    <div className="phone-content">
                        {
                            showList.map((item) => render({
                                node: item, nowChooseItem: choosItem, onDelete, onAdd, onUp, onDown,
                                onChoose, accId, shopId, componentList
                            }))
                        }
                        <div className="add-new-component" onClick={onAdd}>
                            添加组件
                        </div>
                    </div>
                </div>
            </div>
            
            {/* 底部抽屉 - 组件设置 */}
            <Drawer
                title={`组件设置${compMeta?.name ? ` (${compMeta.name})`: ''}`}
                placement="bottom"
                height="70%"
                onClose={() => setChooseItem(null)}
                open={!!choosItem}
                destroyOnClose={true}
                styles={{
                    body: {
                        paddingBottom: 'env(safe-area-inset-bottom)'
                    }
                }}
                extra={
                    <Button type="primary" onClick={() => setChooseItem(null)}>
                        完成
                    </Button>
                }
            >
                <div className="pb-16">
                    {
                        compMeta?.propsSchema ? (
                            <CompForm
                                accId={accId}
                                shopId={shopId}
                                form={form}
                                schema={compMeta.propsSchema}
                                watch={{'#': onChangeFormValue}}
                            />
                        ) : (
                            <div className="text-center text-text-secondary py-8">
                                该组件暂无配置项
                            </div>
                        )
                    }
                </div>
                
                {/* 固定底部保存按钮 */}
                {/* <div className="absolute bottom-0 left-0 right-0 p-4 bg-white border-t border-border-light">
                    <Button type="primary" block size="large" onClick={() => setChooseItem(null)}>
                        完成设置
                    </Button>
                </div> */}
            </Drawer>
            
            <Choose
                visible={addComp.visible}
                componentList={componentList}
                onChoose={confirmAdd}
                onClose={() => setAddComp({
                    visible: false
                })}
            />
        </div>
    );
}

export default Editor;